import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Route } from '../../route';

export function registerReports(): void {
  applicationModuleRegistry.register({
    entry: 'reports',
    id: 'reports',
    name: 'provider.reports',
    route: Route.REPORTS,
    order: 6,
    closeable: true,
  });
}
